/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue'

import '@/assets/css/main.css'
import '@/assets/css/darkMode.css'
import '@/assets/css/iconfont.css'
import 'material-icons/iconfont/material-icons.css'
import 'vuesax/dist/vuesax.css'
import '@/assets/scss/app.scss'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'

Vue.use(Vuesax);

// Theme Configurations
import '../themeConfig.js'

// Globally Registered Components
import '@/globalComponents.js'
import '@/components.js'

// Vue Router
import router from '@/router/router'

// Vuex Store
import store from '@/store/store'

// Vuejs - Vue wrapper for hammerjs
import {VueHammer} from 'vue2-hammer'

Vue.use(VueHammer);

// Tour
import VueTour from 'vue-tour'

Vue.use(VueTour);
require('vue-tour/dist/vue-tour.css');

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

require('@/store/subscriber');

Vue.config.productionTip = false;

//clipboard
import VueClipboard from 'vue-clipboard2'

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

//fontawesome
import '@fortawesome/fontawesome-free/css/all.min.css'

store.dispatch('auth/attempt', {token: localStorage.getItem('token'), tokenExpire: localStorage.getItem('token_expire')}).then(() => {
	new Vue({
		router,
		store,
		render: h => h(App)
	}).$mount('#app')
});

